import type React from 'react'
import type {
  AvatarBlockColumnGap,
  AvatarBlockPadding,
  AvatarBlockRowGap,
} from './AvatarBlock.h'

import {
  AvatarBlockAlignItems,
  AvatarBlockColumnGaps,
  AvatarBlockCorners,
  AvatarBlockDirection,
  AvatarBlockJustifyContent,
  AvatarBlockPaddings,
  AvatarBlockRowGaps,
} from './AvatarBlock.h'
import { AvatarBlockStyled } from './AvatarBlock.styled'

export interface IAvatarBlockProps {
  children: React.ReactNode
  width?: number
  height?: number
  corners?: AvatarBlockCorners
  direction?: AvatarBlockDirection
  justifyContent?: AvatarBlockJustifyContent
  alignItems?: AvatarBlockAlignItems
  rowGap?: AvatarBlockRowGap
  columnGap?: AvatarBlockColumnGap
  padding?: AvatarBlockPadding
  interractive?: boolean
  disabled?: boolean
}

export const AvatarBlock = ({
  children,
  width = 0,
  height = 0,
  direction = AvatarBlockDirection.Column,
  justifyContent = AvatarBlockJustifyContent.FlexStart,
  alignItems = AvatarBlockAlignItems.FlexStart,
  rowGap = AvatarBlockRowGaps.SIZE_0,
  columnGap = AvatarBlockColumnGaps.SIZE_0,
  padding = AvatarBlockPaddings.SIZE_0,
  corners = AvatarBlockCorners.CORNERS_0,
  interractive,
  disabled,
}: IAvatarBlockProps) => (
  <AvatarBlockStyled
    width={width}
    height={height}
    direction={direction}
    justifyContent={justifyContent}
    alignItems={alignItems}
    rowGap={rowGap}
    columnGap={columnGap}
    padding={padding}
    corners={corners}
    interractive={interractive}
    disabled={disabled}
  >
    {children}
  </AvatarBlockStyled>
)
